import { ugeEditors } from 'creation/src/components/uge-gl/types'
import {
    gradientFromEditor,
    iconFromEditor,
    iconScaleFromEditor,
} from 'creation/src/components/uge-gl/utilities/editor'
import { Gradient } from 'types'
import CreationToolOutputType from '../../../types/output-type'
import { CreationToolUploadEditor, CreationToolUploadSource } from '../types'

export function useAvailableEditors(source: CreationToolUploadSource): CreationToolUploadEditor[] {
    if (source.outputType === CreationToolOutputType.Video) {
        return []
    }

    return ugeEditors
        .filter((editor) => {
            switch (editor) {
                case 'layers':
                    return false
                default:
                    return true
            }
        })
        .map((editor) => {
            let title = ''
            let gradient: Gradient | undefined = gradientFromEditor(editor)

            switch (editor) {
                case 'captions':
                    title = 'Add Caption'
                    break
                case 'crop':
                    title = 'Crop'
                    break
                case 'default':
                    gradient = undefined
                    title = 'Open Editor'
                    break
                case 'filters':
                    title = 'Add Filter'
                    break
                case 'stickers':
                    title = 'Add Stickers'
                    break
                default:
                    title = ''
                    break
            }

            return {
                editor,
                gradient,
                icon: iconFromEditor(editor),
                iconScale: iconScaleFromEditor(editor),
                title,
            }
        })
}
